import { TagsModalContent } from './tags-modal-content';

export { TagsModalContent };
